(function () {
  const root = document.querySelector('.main-article[data-medalhao-article-handle]');

  if (!root || root.dataset.medalhaoAnalyticsReady === 'true') return;
  root.dataset.medalhaoAnalyticsReady = 'true';

  const articleBody = root.querySelector('.main-article__body');
  const articleHandle = root.dataset.medalhaoArticleHandle;
  const ga4Destination = root.dataset.medalhaoGa4Destination;

  if (!articleBody || !articleHandle || !ga4Destination) return;

  const destinationType = (pathname) => {
    if (pathname.startsWith('/products/')) return 'product';
    if (pathname.startsWith('/collections/')) return 'collection';
    if (pathname.startsWith('/blogs/')) return 'article';
    if (pathname.startsWith('/pages/')) return 'page';
    return 'other_internal';
  };

  articleBody.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href]');
    if (!link) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;

    const pathname = destination.pathname;
    if (!pathname || pathname === window.location.pathname) return;

    const track = typeof window.gtag === 'function'
      ? window.gtag
      : function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(arguments);
        };

    track('event', 'article_link_click', {
      send_to: ga4Destination,
      article_handle: articleHandle,
      destination_type: destinationType(pathname),
      destination_path: `${pathname}${destination.search}`,
      link_text: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100),
      transport_type: 'beacon',
    });
  });
})();
